import React from 'react';
import { useState } from 'react';
import { NewTestCard, SideBarGPT } from '../../Components';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import axios from 'axios';
import { USER_API } from '../../functions';
import Cookies from 'js-cookie';
import { Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'
import { Dialog } from '@headlessui/react'
import { FcQuestions } from 'react-icons/fc'
import lottie from 'lottie-web';
import Swal from 'sweetalert2';

const NewTests = () => {
  const [TestFound, setTestFound] = useState([]);
  const [showInstructions, setShowInstructions] = useState(false);
  const [ifLoading, setIfLoading] = useState(true);


  const SelectTest = () => {

    const extractName = (name) => {
      const nameArray = name.split("_");
      let result = nameArray[1];
      return result;
    }

    const StartTest = async (test) => {
      localStorage.setItem("test", JSON.stringify(test));

      localStorage.setItem("testId", test.testId);
      setShowInstructions(true);
    }

    if (TestFound.length === 0) {
      return (
        <div className='w-[100%] mt-[4vh] sm:mx-[5vw]'>
          <h1 className='my-[6vh]  font-semibold'>Tests Available</h1>
          <div className='flex justify-center align-bottom flex-wrap '>
            <img src={require(`../../assets/NoDataFound.webp`)} className="max-w-[max(50vw,400px)]" alt="No data Available" />
          </div>
        </div>
      )
    }

    return (
      <div className='w-[100%] mt-[4vh] sm:mx-[5vw]'>
        <h1 className='my-[6vh]  font-semibold'>Tests Available</h1>
        <div className='flex align-middle flex-wrap'>
          {TestFound.map((test) => (
            <NewTestCard name={extractName(test.TestInfo.TestNumber)} duration={test.TestInfo.TestDuration} totalQ={test.QuestionSet.length} totalM={test.QuestionSet.length * 4} callback={StartTest} test={test} disabled={(test.QuestionSet.length !== 0 && test.QuestionSet !== []) ? false : true} />
          ))}
        </div>
      </div>
    )
  }

  const history = useNavigate();
  const navigate = useNavigate();




  const setLoadedData = async () => {
    UserID = localStorage.getItem("user")
    UserID = JSON.parse(UserID);
    if (UserID === null) {
      navigate("/login");
    }
    else {
      try {
        let res = await axios.get(`${USER_API}/getData/${UserID}`);
        if (res.data === null) {
          navigate("/login");
        }
        const data = res.data;
        if (data.ifAdmin) {
          navigate("/Admin")
        }
        const AllTest = await axios.get(`${USER_API}/getTest/${data.Class}`);
        const test = AllTest.data.test;
        setTestFound(test);
        setIfLoading(false);
      }
      catch (err) {
        console.log(err);
        Swal.fire({
          title: 'Error !!',
          text: 'Something went wrong. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Ok'
        })
      }
    }
  }


  const checkuser = async () => {
    const user = Cookies.get("user");
    if (user === undefined) {
      navigate("/login");
    }
    else {
      setLoadedData();
    }


    if (localStorage.getItem("timeOut")) {
      Swal.fire({
        title: 'Warning !!',
        text: 'You have been suspected of leaving test in between. Please contact your teacher.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      }).then(() => {
        localStorage.removeItem("timeOut");
        localStorage.removeItem("testId");
        localStorage.removeItem("test");
      })

    }
  }

  useEffect(() => {
    checkuser();
  }, [])



  const handleFullScreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    let test = JSON.parse(localStorage.getItem("test"));
    let timeOut = Date.now() + (test.TestInfo.TestDuration * 60 * 1000);
    localStorage.setItem("timeOut", timeOut);
    history("/test", { replace: true });
  }

  let UserID = localStorage.getItem("user");
  UserID = JSON.parse(UserID);

  const ref = useRef(null);
  const Loader = () => {
    useEffect(() => {
      const Animator = lottie.loadAnimation({
        container: ref.current,
        animationData: require('../Animations/GeneralLoading.json'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });

      return () => Animator.destroy();
    }, [])

    return (
      <div className='flex justify-center items-center h-screen w-[min(100vw,50rem)] flex-col'>
        <div ref={ref} className='w-[min(100vw,50rem)]'> </div>
        <p>Loading Assets</p>
      </div>
    );

  }


  const Instructions = () => {
    const [open, setOpen] = useState(true)
    const cancelButtonRef = useRef(null)

    setShowInstructions(open);
    const instructions = {
      Title: "Are you sure to start the test?",
      Instructions: "After you start the test, your device will be locked in full screen mode. You will not be able to leave the test in between. If you leave the test in between, you will not be able to attempt it again.",
      Warning: "This test will be evaluated and your marks will be sent to your teacher.\nYou can attempt the question, leave unanswered, mark it for review as per your choice. It will submit automatically after the time is over.",
      CTA: "If you are ready to start the test, click on Start Test button below.",
    }
    return (
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <FcQuestions className="h-6 w-6 text-gray-500" aria-hidden="true" />
                      </div>
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                          {instructions.Title}
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-red-700">
                            {instructions.Instructions}
                          </p>
                          <p className="text-sm text-gray-700">
                            {instructions.Warning}
                          </p>
                          <p className="text-sm text-green-700">
                            {instructions.CTA}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                      onClick={
                        () => {
                          setOpen(false);
                          handleFullScreen();
                        }
                      }
                    >
                      Start Test
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => {
                        localStorage.removeItem("test");
                        localStorage.removeItem("timeOut");
                        localStorage.removeItem("testId");
                        setOpen(false)
                      }}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    )
  }


  return (
    <div className='p-[2vw]'>
      {showInstructions && <Instructions />}
      <div className='MQSidebar'>
        <SideBarGPT />
        {ifLoading ? (
          <Loader />
        ) : (
          <SelectTest />
        )}
      </div>
    </div >
  )
}

export default NewTests
